import { getVersionString } from "@/application/utils/envInfo";
import { ref } from "vue";

const envInfo = ref('-');
getVersionString().then((version) => envInfo.value = version);

export function useEnvInfo() {
  return { versionString: envInfo };
}
